<div class="layout-wrapper">
  <app-top-bar></app-top-bar>
  <div class="content-area">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
